import React, { Component, Fragment } from 'react';
import ApiService from "../../../ApiService";
import DispatchProps from "../../../../utils/DispatchProps";
import Actions from "../../../../redux/Actions";
import { MessageBarType } from "office-ui-fabric-react";
import PageTitle from "../../../PageTitle";
import { IRootState } from "../../../../store";
import { connect } from "react-redux";
import { RolloverStatisticsRow } from '../../../../models/rollover/RolloverStatisticsRow';
import Table, { TableColumn } from '../../../Table';
import TableCell from '../../../TableCell';
import BoolPill from '../../../BoolPill';
import { TARGET_ROLLOVER_SDS_END_DATE_YEAR } from './TenantRolloverPage';
import LoadingCard from '../../../LoadingCard';
import { Doughnut } from 'react-chartjs-2';


interface RolloverStatisticsPageProps {
    apiService: ApiService;
}

interface RolloverStatisticsPageState {
    rolloverStatistics: RolloverStatisticsRow[];
    loadingRolloverStatistics: boolean;
}

class RolloverStatisticsPage extends Component<RolloverStatisticsPageProps & DispatchProps, RolloverStatisticsPageState> {
    static displayName = RolloverStatisticsPage.name;

    private static readonly columns: TableColumn[] = [
        { title: "Tenant", propertyPath: "tenant", enableSort: true, flex: 2 },
        { title: "School", propertyPath: "school", enableSort: true, flex: 2 },
        { title: "Config EndDate", propertyPath: "endDates", flex: 1 },
        { title: "Third Party SDS", propertyPath: "isThirdParty", flex: 1 },
        { title: "Mailroom", propertyPath: "mailroom", flex: 1 },
    ];

    constructor(props: RolloverStatisticsPageProps & DispatchProps) {
        super(props);

        this.state = {
            rolloverStatistics: [],
            loadingRolloverStatistics: false,
        }
    }

    async componentDidMount() {
        await this.load();
    }

    async componentDidUpdate(prevProps: Readonly<RolloverStatisticsPageProps & DispatchProps>, prevState: RolloverStatisticsPageState): Promise<void> {

    }

    private async load() {
        try {
            this.setState({
                rolloverStatistics: [],
                loadingRolloverStatistics: true
            });

            const rolloverStatistics = await this.props.apiService.getRolloversStatistics();

            this.setState({
                rolloverStatistics: rolloverStatistics,
                loadingRolloverStatistics: false,
            });
        }
        catch (e) {
            this.props.dispatch(Actions.showMessageBar(`Error loading rollover statistics. ${e.message}`, MessageBarType.error));

            this.setState({
                loadingRolloverStatistics: false
            });
        }
    }


    private columnsProps = (item: RolloverStatisticsRow, tableColumn: TableColumn, index: number) => {
        switch (tableColumn.propertyPath) {
            case "tenant":
                return <TableCell key={index} flex={tableColumn.flex}>
                    <span>{item.tenantName}</span>
                    <span className={"cdb-table__extra-detail"}>{item.tenantId}</span>
                </TableCell>;
            case "school":
                return <TableCell key={index} flex={tableColumn.flex}>
                    <span>{item.schoolName}</span>
                    <span className={"cdb-table__extra-detail"}>
                        {item.schoolCode}
                        <em> {item.licenseRef}</em>
                    </span>
                </TableCell>;
            case "endDates":
                return <TableCell key={index} flex={tableColumn.flex}>
                    {this.endDatesPill(item)}
                </TableCell>;
            case "isThirdParty":
                return <TableCell key={index} flex={tableColumn.flex}>
                    {this.thirdPartyPill(item)}
                </TableCell>;
            case "mailroom":
                return <TableCell key={index} flex={tableColumn.flex}>
                    {this.mailroomPill(item)}
                </TableCell>;
        }
    }

    private endDatesPill(item: RolloverStatisticsRow) {
        if (item.sdsEndYearInCofig != undefined) {
            return <BoolPill trueText={item.sdsEndYearInCofig} falseText={item.sdsEndYearInCofig} value={item.sdsEndYearInCofig === TARGET_ROLLOVER_SDS_END_DATE_YEAR} falseColour="amber" />

        }
        return null;
    }

    private thirdPartyPill(item: RolloverStatisticsRow) {
        if (item.isThirdParty === true) {
            return <BoolPill trueText="Third Party" falseText="" value={true} />
        }
        return null;
    }

    private mailroomPill(item: RolloverStatisticsRow) {
        if (item.isMailroomRolledOver != undefined) {
            return <BoolPill trueText="Rolled Over" falseText="Not Rolled Over" value={item.isMailroomRolledOver} falseColour="amber" />
        }
        return null;
    }


    private buildDoughnutCard(number: number, total: number, percentage: number, title: string, description: string, verb: string): JSX.Element {
        var doughnutData = {
            labels: [verb, `Not ${verb}`],
            datasets: [{
                data: [number, total - number],
                backgroundColor: [
                    '#99c140',
                    '#e7b416'
                ]
            }]
        }

        return (
            <div className="card flex-item--flex-1 flex-column flex--align-items-center">
                <div className="number-stat">
                    <span className="number-stat__title">
                        {title}
                    </span>
                </div>
                <div className="doughnut-holder--small">
                    <Doughnut data={doughnutData} height={1} width={1} />
                </div>
                <div className="number-stat">
                    <span className="number-stat__number number-stat__number--small">{percentage.toFixed(0)}%</span>
                    <span className="number-stat__description">
                        {number} {description} {verb}
                    </span>
                </div>
            </div>
        )
    }

    private statisticsTableRender() {
        if (this.state.loadingRolloverStatistics === false) {

            const totalEndDates = this.state.rolloverStatistics.length;
            const numberRolledOverEndDates = this.state.rolloverStatistics.filter((row) => row.sdsEndYearInCofig === TARGET_ROLLOVER_SDS_END_DATE_YEAR).length;

            const totalThirdParty = this.state.rolloverStatistics.filter((row) => row.isThirdParty === true).length;
            const numberOfThirdyPartyRolledOver = this.state.rolloverStatistics.filter((row) => row.sdsEndYearInCofig === TARGET_ROLLOVER_SDS_END_DATE_YEAR && row.isThirdParty === true).length;

            const totalMailroom = this.state.rolloverStatistics.filter((row) => row.isMailroomRolledOver != undefined).length;
            const numberOfRolledOverMailroom = this.state.rolloverStatistics.filter((row) => row.isMailroomRolledOver === true).length;

            return <Fragment>
                <div className={"flex-row"}>
                    {this.buildDoughnutCard(numberRolledOverEndDates, totalEndDates, (numberRolledOverEndDates / totalEndDates) * 100, "Total", `Schools with`, `${TARGET_ROLLOVER_SDS_END_DATE_YEAR} Config End Date`)}
                    {this.buildDoughnutCard(numberOfThirdyPartyRolledOver, totalThirdParty, (numberOfThirdyPartyRolledOver / totalThirdParty) * 100, "Third Party", `Third party schools with`, `${TARGET_ROLLOVER_SDS_END_DATE_YEAR} Config End Date`)}
                    {this.buildDoughnutCard(numberOfRolledOverMailroom, totalMailroom, (numberOfRolledOverMailroom / totalMailroom) * 100, "Mailroom", `Mailroom Schools`, `Rolled over`)}
                </div>
                
                <Table
                    title={"Rollovers"}
                    items={this.state.rolloverStatistics}
                    columns={RolloverStatisticsPage.columns}
                    enableSort={true}
                    cellForColumn={this.columnsProps}>
                </Table>
            </Fragment>
        }
        else {
            return <LoadingCard />
        }
    }

    render() {
        return (
            <Fragment>
                <PageTitle title={"Rollovers"} />
                {this.statisticsTableRender()}
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { match: any }): RolloverStatisticsPageProps => {
        return {
            apiService: state.auth.apiService,
        };
    }
)(RolloverStatisticsPage)